import { ToggleButton, ToggleButtonGroup } from "@mui/material";

interface State {
  label: string;
  value: string;
}

interface ToggleProps {
  allState: State[];
  state: string;
  setState: (state: string) => void;
}

export const Toggle = ({ state, allState, setState }: ToggleProps) => {
  return (
    <ToggleButtonGroup exclusive value={state} className="ToggleGroup">
      {allState.map((s) => (
        <ToggleButton
          className="ToggleGroup__Button"
          key={s.value}
          value={s.value}
          sx={{
            width: "5rem",
          }}
          onClick={() => setState(s.value)}
        >
          {s.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
